import { render, staticRenderFns } from "./TresultTable.vue?vue&type=template&id=3114f22f"
import script from "./TresultTable.vue?vue&type=script&lang=js"
export * from "./TresultTable.vue?vue&type=script&lang=js"
import style0 from "./TresultTable.vue?vue&type=style&index=0&id=3114f22f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports